'use client';

import React, { useEffect, useRef } from 'react';

import mapboxgl from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
import { useTheme } from 'next-themes';

type TProps = {
  lat: number;
  lng: number;
  zoom: number;
  //
  lang: string;
};

mapboxgl.accessToken = process.env.NEXT_PUBLIC_MAPBOX_API_TOKEN as string;

const Map = (props: TProps) => {
  const { lat, lng, zoom = 14 } = props;

  const mapContainerRef = useRef(null);
  const { theme } = useTheme();

  const isDarkMode = () =>
    window?.matchMedia &&
    window?.matchMedia('(prefers-color-scheme: dark)')?.matches;

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current as any,
      style:
        theme === 'dark' || (theme === 'system' && isDarkMode())
          ? 'mapbox://styles/mapbox/dark-v11'
          : 'mapbox://styles/mapbox/light-v11',
      center: [lng, lat],
      zoom,
    });

    // Create default markers
    new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);

    // Clean up on unmount
    return () => map.remove();
  }, [lat, lng, zoom, theme]);

  return (
    <div
      className="map-container"
      ref={mapContainerRef}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export default Map;
